module.exports = "../../../../platform/assets/pageMainIcon/simple_baobiaochaxunlei5.svg";